import { memo } from 'react'
import type { FinaleSectionModelProps } from '@/components/home/components/finale-section/finale-section.model'
import { useFinaleSectionModel } from '@/components/home/components/finale-section/finale-section.model'
import { FinaleSectionView } from '@/components/home/components/finale-section/finale-section.view'

export const FinaleSectionViewModel = memo(function FinaleSectionViewModel(
  props: FinaleSectionModelProps,
) {
  const model = useFinaleSectionModel(props)
  return <FinaleSectionView {...model} />
})
